import { render, staticRenderFns } from "./UserInfoAdd.vue?vue&type=template&id=2c30f166&"
import script from "./UserInfoAdd.vue?vue&type=script&lang=js&"
export * from "./UserInfoAdd.vue?vue&type=script&lang=js&"
import style0 from "./UserInfoAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UserInfoAdd.vue"
export default component.exports